import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';

const AdminGuard = () => {
    const { user, loading } = useContext(AuthContext);

    if (loading) return <div>Loading Auth...</div>;

    if (!user || user.tier < 2) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default AdminGuard;